import { ChatInfo } from '@/shared/interfaces/ChatInfo'
import { ContactInfo } from '@/shared/interfaces/ContactInfo'
import { Message } from '@/shared/interfaces/Message'
import { User } from '@/shared/interfaces/User'
import { ApiHandler } from '../ApiHandler'

export abstract class MessageApi {
  public static async send(
    chatId: number,
    args: FormData,
  ): Promise<Message> {
    return await ApiHandler.post(
      `chats/${chatId}/messages`,
      args,
      true,
    )
  }

  public static async editMessage(
    chatId: number,
    args: FormData,
    messageId: number,
  ): Promise<Message> {
    return await ApiHandler.post(
      `chats/${chatId}/messages/${messageId}`,
      args, true,
    )
  }

  /** Получить список сообщений */
  public static async get(
    chatId: number,
    onlyUnread: number,
    page: number,
    type: string,
  ): Promise<{
    page: number;
    page_count: number;
    chat_id: number;
    chat: ChatInfo;
    contact: ContactInfo;
    user: User;
    messages: Message[];
  }> {
    const typeMap = {
      self: 'self',
      channel: 'channels',
      group: 'groups',
    } as const

    const currentType = typeMap[type as keyof typeof typeMap] ?? 'chats'

    return await ApiHandler.get(
      `${currentType}/${chatId}/messages`,
      {only_unread: onlyUnread, page: page},
    )
  }

  /** Получить список сообщений избранного */
  public static async getSelf(): Promise<{
    page: number;
    page_count: number;
    chat_id: number;
    chat: ChatInfo;
    contact: ContactInfo;
    user: User;
    messages: Message[];
  }> {
    return await ApiHandler.get(
      'chats/self',
    )
  }

  /** Получить список сообщений группового чата */
  public static async getFromGroupChat(
    chatId: number,
    onlyUnread: number,
    page: number,
    type?: string,
  ): Promise<{
    page: number;
    page_count: number;
    chat_id: number;
    chat: ChatInfo;
    contact: ContactInfo;
    user: User;
    messages: Message[];
  }> {

    const typeMap = {
      self: 'self',
      channel: 'channels',
      group: 'groups',
    } as const
    const currentType = typeMap[type as keyof typeof typeMap] ?? 'chats'
    const response = await ApiHandler.get(
      `${currentType}/${chatId}/messages`, {only_unread: onlyUnread, page: page},
    )

    response.messages = response.messages.map(
      (messageWithContact: { contact: ContactInfo; message: Message }) => {
        return {
          ...messageWithContact.message,
          contact: messageWithContact.contact,
        }
      },
    )

    return response
  }

  /** Пометить сообщения в чатах как прочитанные */
  public static async markMessagesAsRead(
    chatIds: number[],
  ): Promise<void> {
    await ApiHandler.patch('chats/messages/mark_as_read', {
      chat_ids: chatIds,
    })
  }
}
